import React from 'react';
import { Card } from './ui';

export const SupportHelpTab: React.FC = () => {
  const faqs = [
    {
      question: "How do I connect my WhatsApp number?",
      answer: "Go to the 'WhatsApp Link' tab and scan the QR code displayed using your phone's WhatsApp 'Linked Devices' feature. Ensure your phone remains connected to the internet during the initial sync."
    },
    {
      question: "Why does my status show 'Disconnected'?",
      answer: "Sometimes the connection signal misses the dashboard update. If your orders are still arriving, it's just a visual glitch. You can safely ignore it or refresh the page."
    },
    {
      question: "How are files downloaded?",
      answer: "In the Orders Dashboard, click 'View Files' for an order. You can preview, print, or click 'Download All' to instantly download all files to your computer."
    },
    {
      question: "Can I add staff members?",
      answer: "Yes! Go to the 'Shop Management' tab to invite staff members using their email. They can help process orders without needing access to the WhatsApp connection."
    },
    {
      question: "Do staff members need to scan the WhatsApp QR code?",
      answer: "No. The QR code only needs to be scanned once by the shop owner using the primary business WhatsApp account. Once connected, all invited staff members can log in to the dashboard to view and download order files without needing WhatsApp on their own devices."
    }
  ];

  return (
    <div className="space-y-8 pb-20">
      <div className="space-y-2">
        <h2 className="text-xl font-bold text-slate-900">Frequently Asked Questions</h2>
        <p className="text-sm text-slate-500">Find quick answers to common questions about using ProPrintdeck.</p>
      </div>

      <div className="grid gap-4">
        {faqs.map((faq, index) => (
          <Card key={index} className="p-6 transition-all hover:border-slate-300">
            <h3 className="text-base font-semibold text-slate-900 mb-2">{faq.question}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{faq.answer}</p>
          </Card>
        ))}
      </div>

      {/* Floating WhatsApp Support Button */}
      <a
        href="https://wa.me/918174030202?text=Hi%20Support%20Team,%20I%20need%20help%20with%20PrintDeckDirect." 
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 flex items-center gap-3 bg-[#25D366] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
        </svg>
        <span className="font-semibold tracking-wide">Support Team</span>
      </a>
    </div>
  );
};

export default SupportHelpTab;
